<script setup lang="ts">
import { TypographyComponent } from '../../../'
import { USER_FILTER_FIELD_OPTIONS } from '../../../../constants'
import type { UserCriterion } from '../../../../types'
import CriteriaEnumSelect from '../CriteriaEnumSelect.vue'
import CriteriaFieldCell from '../CriteriaFieldCell.vue'
import CriteriaOperatorValueField from '../CriteriaOperatorValueField.vue'
import { useCriterionField } from '../useCriterionField'

const props = defineProps<{
  row: UserCriterion
  isDisabled?: boolean
}>()
const emits = defineEmits<(e: 'update:row', row: UserCriterion) => void>()

const field = useCriterionField(props, emits, 'field')
const operator = useCriterionField(props, emits, 'operator')
const value = useCriterionField(props, emits, 'value')
</script>

<template>
  <div class="user-fields">
    <CriteriaFieldCell>
      <CriteriaEnumSelect v-model="field" :is-disabled="isDisabled" :options="USER_FILTER_FIELD_OPTIONS" placeholder="Field" size="large" />
    </CriteriaFieldCell>
    <template v-if="row.field">
      <CriteriaOperatorValueField v-model:operator="operator" v-model:value="value" :is-disabled="isDisabled" size="large">
        <template #suffix>
          <TypographyComponent variant="title-large" :font-weight="600">days ago</TypographyComponent>
        </template>
      </CriteriaOperatorValueField>
    </template>
  </div>
</template>

<style scoped lang="scss">
.user-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
</style>
